<template>
  <div>
    <div class="br-pagetitle d-flex justify-content-between align-items-center">
      <div class="d-flex align-items-center">
        <i class="icon ion-card"></i>
        <div class="mg-l-20">
          <h4>{{ $t("order.发票管理") }}</h4>
        </div>
      </div>
      <div class="tx-right">
        <a
          href="javascript:;"
          class="btn btn-success mg-r-15"
          :class="{ 'btn-outline-secondary': checkArrs.length == 0 }"
          @click="exportList"
          >{{ $t("order.导出发票") }}</a
        >
      </div>
    </div>
    <div
      class="d-flex align-items-center justify-content-start pd-x-20 pd-sm-x-30"
    >
      <div class="clear-key">
        <a
          v-show="fCodeFilter"
          href="javascript:;"
          class="mg-r-15"
          @click="clearKey('fCodeFilter')"
        >
          {{ $t("purchase.采购单：") }}
          <span class="mg-r-10">{{ fCodeFilter }}</span>
          <i class="fa fa-close"></i>
        </a>
        <a
          v-show="fFilterSku"
          href="javascript:;"
          class="mg-r-15"
          @click="clearKey('fFilterSku')"
        >
          {{ $t("order.客户系统订单号：") }}
          <span class="mg-r-10">{{ fFilterSku }}</span>
          <i class="fa fa-close"></i>
        </a>
        <a
          v-show="fCodeinvoicesFilter"
          href="javascript:;"
          class="mg-r-15"
          @click="clearKey('fCodeinvoicesFilter')"
        >
          {{ $t("order.发票编号") }}：
          <span class="mg-r-10">{{ fCodeinvoicesFilter }}</span>
          <i class="fa fa-close"></i>
        </a>
        <a
          v-show="fTimeCreatedFrom || fTimeCreatedTo"
          @click="clearKey('timefilter')"
          href="javascript:;"
          class="mg-r-15"
        >
          {{ $t("order.上传时间：") }}
          <span class="mg-r-10"
            >{{ fTimeCreatedFrom }} {{ $t("mall.至") }}
            {{ fTimeCreatedTo }}</span
          >
          <i class="fa fa-close"></i>
        </a>
        <div class="mg-l-auto"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: [
    "checkArrs",
    "fCodeFilter",
    "fFilterSku",
    "fCodeinvoicesFilter",
    "fTimeCreatedFrom",
    "fTimeCreatedTo",
  ],
  methods: {
    clearKey(type) {
      this.$emit("clearKey", type);
    },
    exportList() {
      this.$emit("exportList");
    },
  },
};
</script>
